module.exports = __webpack_public_path__ + "static/media/slideshare.0eed356c.svg";